export enum MaintenanceViewType {
  Calendar = "calendar",
  Table = "table",
}

export enum MaintenanceViewStatusType {
  Open = "open",
  Upcoming = "upcoming",
  History = "history",
}
